import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireSiteConfig?: boolean;
}

export const ProtectedRoute = ({ children, requireSiteConfig = false }: ProtectedRouteProps): React.ReactElement | null => {
  const { user, loading, siteConfig } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireSiteConfig && !siteConfig) {
    return <Navigate to="/settings" replace />;
  }

  return <>{children}</>;
};
